/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_close': {
    width: 38,
    height: 19,
    viewBox: '0 0 38 19',
    data: '<path pid="0" d="M35.625 16.75L19 2.5 2.375 16.75" _stroke="#9395A2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
